import { Menu } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { useSidebar } from "./Sidebar";
import { useAuth } from "../../context/AuthContext";
import { useBrandLogo } from "../../lib/branding";

// Top bar shown only on mobile (<md). Acts as the "app chrome" when the
// sidebar is hidden — gives users a hamburger to open the sidebar drawer +
// shows the Kinntegra logo + a quick avatar/initials.
const MobileTopBar = () => {
  const { isMobile, setMobileOpen } = useSidebar();
  const { user } = useAuth();
  const navigate = useNavigate();
  const logo = useBrandLogo();
  if (!isMobile) return null;

  const initials = (user?.name || user?.email || "?")
    .split(/\s+/)
    .map((p) => p[0])
    .filter(Boolean)
    .slice(0, 2)
    .join("")
    .toUpperCase();

  return (
    <header
      className="sticky top-0 z-30 flex items-center justify-between gap-3 px-3 h-14 bg-[rgb(var(--brand-1))] border-b border-white/5 shadow-sm"
      data-testid="mobile-topbar"
    >
      <button
        onClick={() => setMobileOpen(true)}
        className="p-2 -ml-1 rounded-md text-white/80 hover:bg-white/[0.06] active:bg-white/10"
        data-testid="mobile-menu-button"
        aria-label="Open menu"
      >
        <Menu className="w-5 h-5" />
      </button>

      <div className="flex items-center gap-2 flex-1 justify-center">
        {logo ? (
          <span className="flex h-9 max-w-[160px] items-center rounded-md bg-white/95 px-2 py-1" data-testid="mobile-brand-logo">
            <img src={logo} alt="Logo" className="max-h-full max-w-full object-contain" />
          </span>
        ) : (<>
          <span className="text-white tracking-[0.18em] text-xs font-medium">KINNTEGRA</span>
          <span className="h-[6px] w-[6px] rounded-full bg-[rgb(var(--brand-2))]" />
        </>)}
      </div>

      <button
        onClick={() => navigate("/settings")}
        className="w-8 h-8 rounded-full bg-[rgb(var(--brand-2))] text-[rgb(var(--brand-1))] text-xs font-bold flex items-center justify-center"
        data-testid="mobile-avatar"
        aria-label="Profile"
      >
        {initials || "U"}
      </button>
    </header>
  );
};

export default MobileTopBar;
